module.exports = __webpack_public_path__ + "static/media/se.1f642770.svg";